import { apiFuns } from "sw-hic";
let { get, put, del, post, genStandard, exceptedReqs, download } = apiFuns;
const api = {
  /*********** 住院记录 ***********/
  Hospitalization: genStandard("hospitalization", "/api/ip", false),
  /*********** 医嘱记录 ***********/
  Advice: {
    ...genStandard("advice", "/api/ip"),
    // putAdviceSta: (ids, state, ipDiagnosisId, execTime, memo) => {
    //   let data = { ids };
    //   if (ipDiagnosisId) data.ipDiagnosisId = ipDiagnosisId;
    //   if (execTime) data.execTime = execTime;
    //   if (memo) data.memo = memo;
    //   return apiFuns.put(`/api/ip/advice/state/${state}`, data);
    // },
    action: (type, para) => apiFuns.put(`/api/ip/advice/action/${type}`, para), // 操作医嘱
    back: (id) => apiFuns.put(`/api/ip/advice/${id}/back`), // 回退
    queryForAction: (action, para) => apiFuns.get(`/api/ip/advice/action/${action}`, para), // 操作医嘱查询
    print: (para) => apiFuns.get(`/api/ip/advice/print`, para), // 医嘱打印数据
    printDrug: (para) => apiFuns.get(`/api/ip/advice/print/drug`, para), // 口服药单打印数据
    // exec: (para) => apiFuns.post(`/api/ip/advice/exec`, para), // 执行
    // stop: (para) => apiFuns.post(`/api/ip/advice/stop`, para), // 停止
    // Transfer: {
    //   exec: (id) => apiFuns.post(`/api/ip/advice/${id}/transfer`), // 转科医嘱执行
    //   cancel: (id) => apiFuns.delete(`/api/ip/advice/${id}/transfer`), // 取消转科医嘱执行
    // },
    // Leave: {
    //   exec: (id) => apiFuns.post(`/api/ip/advice/${id}/leave`), // 出院医嘱执行
    //   cancel: (id) => apiFuns.delete(`/api/ip/advice/${id}/leave`), // 取消出院医嘱执行
    // }
  },
  /*********** 医嘱操作记录 ***********/
  AdviceLog: genStandard("adviceLog", "/api/ip"),
  /*********** 记账记录 ***********/
  Billing: {
    ...genStandard("billing", "/api/ip"),
    sum: (para) => apiFuns.get(`/api/ip/billing/sum`, para),
  },

  /*********** 标准费用 ***********/
  FeeStandard: genStandard("feeStandard", "/api/md"),
  MlItem: genStandard("item", "/api/ml"),
  Drug: {
    getDrugs: (para) => apiFuns.get(`/api/drug/stock/rp`, para),
  },
  ExportExcel: {
    getAdviceCount: (para) => apiFuns.get(`/api/ip/export/advice/count`, para),
    downloadAdvice: (para) => apiFuns.download(`/api/ip/export/advice?ifNotExport=${para.ifNotExport}`, {}),
    getAdviceStoppedCount: (para) => apiFuns.get(`/api/ip/export/adviceStopped/count`, para),
    downloadAdviceStopped: (para) => apiFuns.download(`/api/ip/export/adviceStopped`, {}),
    downloadTreatment: (para) => apiFuns.download(`/api/ip/export/treatment`, para, '', 'POST'),
    downloadDrug: (para) => apiFuns.download(`/api/ip/export/drug`, para, '', 'POST'),
  }
};

export default api;
